import { createModule } from "saga-slice";
import { call, put } from "redux-saga/effects";
import { createSale, getSales, getSaleById, getTotalSalesToday, getTotalSalesThisWeek, getTotalSalesThisMonth, getTotalSalesThisYear, getTotalSalesForDateRange, getSalesData, search, getSalesReport, filterSales, printReceipt, saveItem, fetchOpenSales, removeItem, updateItemQuantity, closeSale, updatePrice, saveEditedItem, updateEditedItemQuantity, updateEditedPrice, removeEditedItem, closeEditedSale } from "../services/saleService";
import { clear } from "toastr";

const saleModule = createModule({
  name: "sales",
  initialState: {
    isLoading: false,
    error: null,
    currentSale: null,
    isExisting: false,
    cart: [],
    sales: [],
    items: [],
    totalSales: 0,
    stockValue: 0,
    totalRefunds: 0,
    totalPurchases: 0,
    lowStockItems: [],
    highlightedItem: null,
    totalAmount: 0,
    totalElements: 0, // Total number of records
    totalPages: 0, // Total number of pages
    pageNumber: 0, // Current page number
    pageSize: 30, // Size of each page
    barcodeFocus: false,
    editedSale: null,
    editedCart: [],
    editedTotalAmount: 0
  },
  selectors: {
    getCart: state => state.sales?.cart || [],
    getTotalAmount: state => state.sales?.totalAmount || 0,
    getIsLoading: state => state.sales?.isLoading || false
  },
  reducers: {
    search: (state) => {
      state.isLoading = true;
    },
    setBarcodeFocus: (state, action) => {
      state.barcodeFocus = action;
    },
    createSale: (state, action) => {
      state.isLoading = true;
      state.error = null;
    },
    getSalesData: (state) => {
      state.isLoading = true;
    },
    getSalesDataSuccess: (state, action) => {
      state.isLoading = false;
      state.totalSales = action.totalSales;
      state.stockValue = action.stockValue;
      state.totalRefunds = action.totalRefunds;
      state.lowStockItems = action.lowStockItems;
      state.totalPurchases = action.totalPurchases;

    },

    getSaleById: (state) => {
      state.isLoading = true;
    },

    getSalesDataFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    finishFetching: (state) => {
      state.isLoading = false;
    },

    fetchedData: (state, payload) => {
      state.isLoading = false;
      state.sales = payload.body;
    },

    handleAddOrUpdateItem: (state) => {
      state.isLoading = true;
    },
    handleAddOrUpdateEditedItem : (state) => {
      state.isLoading = true;
    },

    fetchedItemsData: (state, payload) => {
      state.isLoading = false;
      state.items = payload.body;
    },

    getTotalSalesToday: (state, action) => {
      state.isLoading = true;
      state.error = null;
    },

    getTotalSalesThisWeek: (state, action) => {
      state.isLoading = true;
      state.error = null;
    },

    getTotalSalesThisMonth: (state, action) => {
      state.isLoading = true;
      state.error = null;
    },

    getTotalSalesThisYear: (state, action) => {
      state.isLoading = true;
      state.error = null;
    },

    createSaleSuccess: (state, action) => {
      state.isLoading = false;
      state.cart = [];
      state.totalAmount = 0;
      state.currentSale = action.payload;
    },

    createSaleFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    search: (state) => {
      state.isLoading = true;
    },
    getSalesReport: (state) => {
      state.isLoading = true;
    },
    filterSales: (state) => {
      state.isLoading = true;
    },
    printReceipt: (state) => {
      state.isLoading = true;
    },
    handleUpdateQuantity: (state) => {
      state.isLoading = true;
    },
    handleUpdateEditedQuantity: (state) => {
      state.isLoading = true;
    },
    fetchOpenSale: (state) => {
      state.isLoading = true;
    },
    fetchOpenSaleSuccess: (state, action) => {
      state.isLoading = false;
      state.currentSale = action;
      state.cart = (action?.items || []).reverse();
      state.totalAmount = action?.items?.reduce((total, item) => total + item.price * item.quantity, 0) || 0;
    },
    fetchEditedSaleSuccess: (state, action) => {
      state.isLoading = false;
      state.editedSale = action;
      state.editedCart = (action?.items || []).reverse();
      state.editedTotalAmount = action?.items?.reduce((total, item) => total + item.price * item.quantity, 0) || 0;
    },
    clearState: (state) => {
      state.isLoading = false;
      state.error = null;
      state.currentSale = null;
      state.cart = [];
      state.totalAmount = 0;
    },

    addToCart: (state, action) => {
      const existingItem = state.cart.find(item => item.id === action.id);
      if (existingItem) {
        existingItem.quantity = action.quantity; // Update quantity if item already exists
        state.isExisting = true;
      } else {
        state.cart.unshift({ ...action }); // Add to the beginning of the array
        state.isExisting = false;
      }
      // Highlight current item being added
      state.highlightedItem = action.id;
      state.currentSale = { ...state.currentSale, id: action.saleId };

      state.totalAmount = state.cart.reduce(
        (total, item) => total + item.price * item.quantity,
        0
      );
    },
    addToEditedCart: (state, action) => {
      const existingItem = state.editedCart.find(item => item.id === action.id);
      if (existingItem) {
        existingItem.quantity = action.quantity; // Update quantity if item already exists
        state.isExisting = true;
      } else {
        state.editedCart.unshift({ ...action }); // Add to the beginning of the array
        state.isExisting = false;
      }
      // Highlight current item being added
      state.highlightedItem = action.id;
      state.editedSale = { ...state.editedSale, id: action.saleId };

      state.editedTotalAmount = state.editedCart.reduce(
        (total, item) => total + item.price * item.quantity,
        0
      );
    },

    closeSale: (state) => {
      state.isLoading = true;
      state.error = null;
    },

    closeEditedSale: (state) => {
      state.isLoading = true;
      state.error = null;
    },

    setTotalSales: (state, action) => {
      state.totalSales = action.payload;
    },

    handleRemoveFromCart: (state, action) => {
      state.isLoading = true;

    },
    handleRemoveFromEditedCart: (state, action) => {
      state.isLoading = true;
    },

    removeFromCart: (state, action) => {
      state.cart = state.cart.filter(item => item.id !== action);
      state.totalAmount = state.cart.reduce((total, item) =>
        total + (item.price * item.quantity), 0);
    },

    removeFromEditedCart: (state, action) => {
      state.editedCart = state.editedCart.filter(item => item.id !== action);
      state.editedTotalAmount = state.editedCart.reduce((total, item) =>
        total + (item.price * item.quantity), 0);
    },

    updateQuantity: (state, action) => {
      const item = state.cart.find(item => item.id === action.id);
      if (item) {
        item.quantity = action.quantity;
        // Highlight current item being edited
        state.highlightedItem = action.id;

        // Remove the item from its current position
        state.cart = state.cart.filter(i => i.id !== action.id);
        // Add the updated item to the beginning of the array
        state.cart.unshift(item);

        state.totalAmount = state.cart.reduce(
          (total, itm) => total + itm.price * itm.quantity,
          0
        );
      }
    },

    updateEditedQuantity: (state, action) => {
      const item = state.editedCart.find(item => item.id === action.id);
      if (item) {
        item.quantity = action.quantity;
        // Highlight current item being edited
        state.highlightedItem = action.id;

        // Remove the item from its current position
        state.editedCart = state.editedCart.filter(i => i.id !== action.id);
        // Add the updated item to the beginning of the array
        state.editedCart.unshift(item);

        state.editedTotalAmount = state.editedCart.reduce(
          (total, itm) => total + itm.price * itm.quantity,
          0
        );
      }
    },

    updatePrice: (state, action) => {
      const item = state.cart.find(item => item.id === action.id);
      if (item) {
        item.price = action.price;
        // Highlight current item being edited
        state.highlightedItem = action.id;

        state.totalAmount = state.cart.reduce(
          (total, itm) => total + itm.price * itm.quantity,
          0
        );
      }
    },

    updateEditedPrice: (state, action) => {
      const item = state.editedCart.find(item => item.id === action.id);
      if (item) {
        item.price = action.price;
        // Highlight current item being edited
        state.highlightedItem = action.id;
        state.editedTotalAmount = state.editedCart.reduce(
          (total, itm) => total + itm.price * itm.quantity,
          0
        );
      }
    },

    handleUpdatePrice: (state) => {
      state.isLoading = true;
    },
    handleUpdateEditedPrice: (state) => {
      state.isLoading = true;
    },

    clearCart: (state) => {
      state.cart = [];
      state.totalAmount = 0;
    },
    clearEditedCart: (state) => {
      state.editedCart = [];
      state.editedTotalAmount = 0;
    },
    fetchError: (state, action) => {
      state.loading = false;
      state.error = action || "An error occurred";
    },
  },
  sagas: (A) => ({
    *[A.search]({ payload }) {
      try {
        const { onSuccess, filterType, startDate, endDate, query } = payload;
        const { data } = yield call(search, filterType, startDate, endDate, query);
        yield put(A.finishFetching());
        yield put(A.fetchedData(data));

        if (onSuccess) {
          yield call(onSuccess);
        }
      } catch (e) {
        console.log(e);
        yield put(A.finishFetching());
        yield put(A.fetchError());
      }
    },
    *[A.getSaleById]({ payload }) {
      try {
        const { id, onSuccess } = payload;
        const { data } = yield call(getSaleById, id);
        yield put(A.finishFetching());
        yield put(A.fetchEditedSaleSuccess(data?.body));

        if (onSuccess) {
          yield call(onSuccess, data);
        }
      } catch (e) {
        console.log(e);
        yield put(A.finishFetching());
        yield put(A.fetchError());
      }
    },
    *[A.fetchOpenSale]() {
      try {
        const { data } = yield call(fetchOpenSales);
        yield put(A.finishFetching());
        yield put(A.fetchOpenSaleSuccess(data));
      } catch (e) {
        console.log(e);
        yield put(A.finishFetching());
        yield put(A.fetchError());
      }
    },

    *[A.closeSale]({ payload }) {
      try {
        const { data } = yield call(closeSale, payload.id);
        yield put(A.finishFetching());
        yield put(A.clearState());
        yield call(payload.onSuccess, data);
      } catch (e) {
        console.log(e);
        yield put(A.finishFetching());
        yield put(A.fetchError());
      }
    },

    *[A.closeEditedSale]({ payload }) {
      try {
        const { data } = yield call(closeEditedSale, payload.id);
        yield put(A.finishFetching());
        yield put(A.clearEditedCart());
        yield call(payload.onSuccess, data);
      } catch (e) {
        console.log(e);
        yield put(A.finishFetching());
        yield put(A.fetchError());
      }
    },


    *[A.printReceipt]({ payload }) {
      try {
        const { data } = yield call(printReceipt, payload.id);
        yield put(A.finishFetching());
        yield call(payload.onSuccess, data);
      } catch (e) {
        console.log(e);
        yield put(A.finishFetching());
        yield put(A.fetchError());
      }
    },
    *[A.handleRemoveFromCart]({ payload }) {
      try {
        const itemId = payload.id;
        // Call the API to remove the item from the backend
        // Replace 'removeItem' with your actual API call
        yield call(removeItem, itemId);
        // Dispatch the removeFromCart action with the item ID
        yield put(saleActions.removeFromCart(itemId));
        yield put(A.finishFetching()); // Optionally set loading to false
      } catch (error) {
        console.error("Error in handleRemoveFromCart saga:", error);
        yield put(A.fetchError(error.message)); // Dispatch fetchError action
        yield put(A.finishFetching()); // Ensure loading is set to false
      }
    },

    *[A.handleRemoveFromEditedCart]({ payload }) {
      try {
        const itemId = payload.id;
        // Call the API to remove the item from the backend
        // Replace 'removeItem' with your actual API call
        yield call(removeEditedItem, itemId);
        // Dispatch the removeFromEditedCart action with the item ID
        yield put(saleActions.removeFromEditedCart(itemId));
        yield put(A.finishFetching()); // Optionally set loading to false
      } catch (error) {
        console.error("Error in handleRemoveFromEditedCart saga:", error);
        yield put(A.fetchError(error.message));
        yield put(A.finishFetching());
      }
    },
    
    *[A.handleUpdateQuantity]({ payload }) {
      try {
        const itemId = payload.id;
        const quantity = payload.quantity;

        // Call the API to update the item's quantity in the backend
        // Replace 'updateItemQuantity' with your actual API call
        yield call(updateItemQuantity, itemId, quantity);

        // Dispatch the updateQuantity action with the item ID and new quantity
        yield put(saleActions.updateQuantity({ id: itemId, quantity }));
        yield put(A.finishFetching()); // Optionally set loading to false
      } catch (error) {
        console.error("Error in handleUpdateQuantity saga:", error);
        yield put(A.fetchError(error.message)); // Dispatch fetchError action
        yield put(A.finishFetching()); // Ensure loading is set to false
      }
    },

    *[A.handleUpdateEditedQuantity]({ payload }) {
      try {
        const itemId = payload.id;
        const quantity = payload.quantity;

        yield call(updateEditedItemQuantity, itemId, quantity);

        yield put(saleActions.updateEditedQuantity({ id: itemId, quantity }));
        yield put(A.finishFetching());
      } catch (error) {
        console.error("Error in handleUpdateQuantity saga:", error);
        yield put(A.fetchError(error.message));
        yield put(A.finishFetching());
      }
    },

    *[A.handleUpdatePrice]({ payload }) {
      try {
        // Assuming payload contains the item to add or update
        const { id, price } = payload;

        yield call(updatePrice, id, price);
        // Dispatch the addToCart action with the item
        yield put(saleActions.updatePrice({ id, price }));
        yield put(A.finishFetching()); // Optionally set loading to false
      } catch (error) {
        console.error("Error in handleAddOrUpdateItem saga:", error);
        yield put(A.fetchError(error.message)); // Dispatch fetchError action
        yield put(A.finishFetching()); // Ensure loading is set to false
      }
    },

    *[A.handleUpdateEditedPrice]({ payload }) {
      try {
        // Assuming payload contains the item to add or update
        const { id, price } = payload;
        yield call(updateEditedPrice, id, price);
        // Dispatch the addToCart action with the item
        yield put(saleActions.updateEditedPrice({ id, price }));
        yield put(A.finishFetching()); // Optionally set loading to false
      } catch (error) {
        console.error("Error in handleAddOrUpdateItem saga:", error);
        yield put(A.fetchError(error.message));
        yield put(A.finishFetching());
      }
    },

    *[A.handleAddOrUpdateItem]({ payload }) {
      try {
        // Assuming payload contains the item to add or update
        const item = payload;

        // Call the API to save the item in the backend
        // Replace 'saveItem' with your actual API call
        const { data } = yield call(saveItem, item);

        // Dispatch the addToCart action with the item (including the ID from the backend)
        yield put(saleActions.addToCart(data));
        yield put(A.finishFetching()); // Optionally set loading to false
      } catch (error) {
        console.error("Error in handleAddOrUpdateItem saga:", error);
        yield put(A.fetchError(error.message)); // Dispatch fetchError action
        yield put(A.finishFetching()); // Ensure loading is set to false
      }
    },
    *[A.handleAddOrUpdateEditedItem]({ payload }) {
      try {
        // Assuming payload contains the item to add or update
        const item = payload;

        // Call the API to save the item in the backend
        // Replace 'saveItem' with your actual API call
        const { data } = yield call(saveEditedItem, item);

        // Dispatch the addToCart action with the item (including the ID from the backend)
        yield put(saleActions.addToEditedCart(data));
        yield put(A.finishFetching()); // Optionally set loading to false
      } catch (error) {
        console.error("Error in handleAddOrUpdateItem saga:", error);
        yield put(A.fetchError(error.message)); // Dispatch fetchError action
        yield put(A.finishFetching()); // Ensure loading is set to false
      }
    },
    *[A.filterSales]({ payload }) {
      try {
        const { onSuccess, filterType, startDate, endDate, query, page, size } = payload;
        const { data } = yield call(filterSales, filterType, startDate, endDate, query, page, size);
        yield put(A.finishFetching());
        yield put(A.fetchedItemsData(data));

        if (onSuccess) {
          yield call(onSuccess);
        }
      } catch (e) {
        console.log(e);
        yield put(A.finishFetching());
        yield put(A.fetchError());
      }
    },
    *[A.createSale]({ payload }) {
      try {
        const saleData = {
          items: payload.items,
          totalAmount: payload.totalAmount
        };

        const { data } = yield call(createSale, saleData);
        yield put(A.createSaleSuccess());

        if (payload.onSuccess) {
          yield call(payload.onSuccess, data);
        }
      } catch (error) {
        yield put(A.createSaleFailure(error.message));
        if (payload.onError) {
          yield call(payload.onError, error.response.data);
        }
      }
    },
    *[A.getSalesData]({ payload }) {
      try {
        const { data } = yield call(getSalesData, payload.dateRange);
        yield put(A.getSalesDataSuccess(data));
      } catch (error) {
        yield put(A.getSalesDataFailure(error.message));
      }
    },
    *[A.getSalesReport]({ payload }) {
      try {
        const { data } = yield call(getSalesReport, payload.dateRange);
        yield put(A.finishFetching());
        if (payload.onSuccess) {
          yield call(payload.onSuccess, data.body);
        }
      } catch (error) {
        yield put(A.finishFetching());
        yield put(A.getSalesDataFailure(error.message));

      }
    },
    *[A.fetchSales]({ payload }) {
      try {
        const { data } = yield call(getSales, payload.page, payload.size);
        yield put(A.setSales(data.content));
        yield put(A.setPagination({
          currentPage: payload.page,
          totalPages: data.totalPages,
          pageSize: payload.size,
          totalElements: data.totalElements
        }));
      } catch (error) {
        yield put(A.setError(error.message));
      }
    },
    *[A.getTotalSalesToday]() {
      try {
        const { data } = yield call(getTotalSalesToday);
        yield put(A.setTotalSales(data));
      } catch (error) {
        yield put(A.setError(error.message));
      }
    },
    *[A.getTotalSalesThisWeek]() {
      try {
        const { data } = yield call(getTotalSalesThisWeek);
        yield put(A.setTotalSales(data));
      } catch (error) {
        yield put(A.setError(error.message));
      }
    },
    *[A.getTotalSalesThisMonth]() {
      try {
        const { data } = yield call(getTotalSalesThisMonth);
        yield put(A.setTotalSales(data));
      } catch (error) {
        yield put(A.setError(error.message));
      }
    },
    *[A.getTotalSalesThisYear]() {
      try {
        const { data } = yield call(getTotalSalesThisYear);
        yield put(A.setTotalSales(data));
      } catch (error) {
        yield put(A.setError(error.message));
      }
    },
    *[A.getTotalSalesForDateRange]({ payload }) {
      try {
        const { data } = yield call(getTotalSalesForDateRange, payload.startDate, payload.endDate);
        yield put(A.setTotalSales(data));
      } catch (error) {
        yield put(A.setError(error.message));
      }
    }
  }),

});

export default saleModule;
export const saleActions = saleModule.actions;